import React from "react";
import PropTypes from "prop-types";
import Str from "shared/components/Str";
import classnames from "classnames";

import { SECTIONS } from "apps/discovery/util/consts";

import "./BlankRow.scss";

const BlankRow = (props) => {
	const blankRowClasses = classnames({
		"blank-row": true,
		"blank-row--gray": props.color === "gray",
		"blank-row--blue": props.color === "blue",
	});

	const isImportantQuestions = props.sectionId === SECTIONS.important_questions;

	return (
		<div className={blankRowClasses}>
			{props.sectionId === SECTIONS.interests &&
				<div className="blank-row-interest">
					<div className="blank-row-interest-icon" />
					<div className="blank-row-interest-text">
						<span className="blank-row-interest-title">
							<Str>Whoops, we aren’t seeing anyone who mentioned this.</Str>
						</span>
						<span className="blank-row-interest-subtitle">
							<Str>Try searching something else!</Str>
						</span>
					</div>
				</div>
			}
			{props.sectionId !== SECTIONS.interests &&
				<div className="blank-row-content">
					<span className="blank-row-title">
						{isImportantQuestions &&
							<Str>We can’t find anyone who answered this way!</Str>
						}
						{!isImportantQuestions &&
							<Str>We can’t find anyone to put here!</Str>
						}
					</span>
					<span className="blank-row-subtitle">
						<Str>Try expanding your filters to see more people.</Str>
					</span>
				</div>
			}
		</div>
	);
};

BlankRow.propTypes = {
	color: PropTypes.string.isRequired,
	sectionId: PropTypes.string.isRequired,
};

export default BlankRow;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/BlankRow.jsx